// components/StatCard.jsx
import React from 'react';
import { ArrowUpRight, ArrowDownRight, SaudiRiyalIcon } from 'lucide-react';
import i18n from '../../i18n';

class VatCard extends React.Component {
  render() {
    const {
      icon: Icon,
      className,
      title,
      value,
      trend,
      percentage,
      timeframe,

      // color = 'green', // or 'red', 'yellow', etc.
    } = this.props;

    const isPositive = trend === 'up';
    const TrendIcon = isPositive ? ArrowUpRight : ArrowDownRight;

    return (
      <div className={`stat-card`}>
        <div className="stat-card-body">
          <div className={`stat-card-icon ${className}`}>
            <Icon size={24} />
          </div>
          <div className="stat-card-text">
            <div className="stat-header">{title}</div>
            <div className="stat-value">
              {value} <span className="currency"><SaudiRiyalIcon/> </span>
            </div>
            <div className="stat-footer">
              <div className={`stat-change ${isPositive ? 'positive' : 'negative'}`}>
                <div className="icon">
                  <TrendIcon size={14} />
                </div>
                <span>{(isPositive ? '+' : '') + percentage}%</span>
              </div>
              <span className="stat-timeframe">{timeframe}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default VatCard;
